export default __webpack_public_path__ + "static/media/2.1752e8b1.jpg";